import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Col, Modal, Row } from "reactstrap";
import { Tooltip } from "@mui/material";
import PndRestApi from "src/utils/pnd/PndRestApi";
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import ReactTableBase from "src/shared/components/table/ReactTableBase";
import { showNotification, successNofication } from "src/shared/components/Notification";
import Radio from '@mui/material/Radio';
import { Cancel } from '@mui/icons-material';
import { ADDRESS_TYPE_ANOTHER_HUB, ADDRESS_TYPE_HUB_CUSTOMER, ADDRESS_TYPE_MERCHANT, ADDRESS_TYPE_MERCHANT_CUSTOMER, ADDRESS_TYPE_OWN_HUB, ERROR_MESSAGES, OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT, ORDER_TYPE_DROP_OFF } from '../../../../../../../utils/pnd/PndConstants';
import { calculateTTP } from "src/utils/pnd/googleDistanceUtility";
import { Link } from '@mui/material';
import { Redirect } from 'react-router-dom'
import Badge from "react-bootstrap/Badge";
const FreeRiderDetails = ({ modalShow, setModalShow, isOrderNo, setSelectedDriverId, selectedDriverId,
    isOrderId, isOperationType, selectedOrderIds, isOrderType, setRedirect, data, setBulkUploadReDirect, selectedHubId }) => {

    const [selectedItem, setSelectedItem] = useState(0);
    const [reactTableData, setReactTableData] = useState([]);
    const [isTempData, setTempData] = useState(null);
    const [initialLoad, setInitialLoad] = useState(true);
    const [isNoFreeRiderFound, setNoFreeRiderFound] = useState(false);
    const [isRiderRedirect, setRiderRedirect] = useState(false);

    let Icon;

    useEffect(() => {
        if (initialLoad) {
            GetAllFreeRiderDetails();
            // getPickUpLocationGeoData();
            setInitialLoad(false);
        }

    }, [initialLoad]);


    const OrderStatusUpdate = async () => { //use for individual order status update
        try {

            let Obj = {};
            Obj["operationType"] = isOperationType;
            Obj["orderId"] = isOrderId;
            Obj["hubId"] = isTempData?.hubId;
            Obj["riderId"] = selectedDriverId ? selectedDriverId : null;
            Obj["vehicleId"] = isTempData?.vehicleId;
            Obj["riderStatusId"] = isTempData?.riderStatusId;
            const response = await PndRestApi.UpdateOrderStatusDetails(Obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `Message: Order Status Updated Successfully`
                );
                toggle();
                setRedirect(true);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };


    const OrderBulkAssignment = async () => { //use for individual order status update
        try {

            let Obj = {};
            Obj["operationType"] = OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT;

            if (OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT == Obj["operationType"]) {
                const orderIdStrings = selectedOrderIds.map(order => String(order.id));
                Obj["orderId"] = orderIdStrings;
            } else {
                Obj["orderId"] = isOrderId;
            }
            Obj["hubId"] = isTempData?.hubId;
            Obj["riderId"] = selectedDriverId ? selectedDriverId : null;
            Obj["vehicleId"] = isTempData?.vehicleId;
            Obj["riderStatusId"] = isTempData?.riderStatusId;

            const response = await PndRestApi.OrderBulkAssignmentProcess(Obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `Message: Order Status Updated Successfully`
                );
                toggle();
                setBulkUploadReDirect(true);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    const handleAssignButtonClick = (event) => {
        event.preventDefault(); // Prevent default form submission behavior
        if (isOperationType === OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT)
            OrderBulkAssignment();
        else {
            OrderStatusUpdate();
        }
    };
    const GetAllFreeRiderDetails = async () => {
        try {
            let orderType = isOrderType ? isOrderType : 0; //isOrderType will be 3 for PnD if the bulk assignment it is 0 always
            if(selectedHubId === null || selectedHubId === '' || selectedHubId === 'null'|| selectedHubId === undefined) selectedHubId = -1;
            const response1 = await PndRestApi.GetAllFreeRidersDetails(orderType, selectedHubId); //3-PnD

            if (response1 && response1.status === 200 && response1.data.status === 200) {
                if (response1.data.data.length > 0) {
                    const tableData = [...response1.data.data];

                    /** finding pick up location */
                    let response;
                    let destinationParam = null;
                    if (data && data.orderType !== ORDER_TYPE_DROP_OFF) {
                        const orderAddressTypeId = data?.orderFromAddressTypeInfo?.orderAddressTypeId;
                        if (orderAddressTypeId === ADDRESS_TYPE_MERCHANT) {
                            response = await PndRestApi.GetMerchantById(data.fromUniqueId);
                            if (response && response.status === 200 && response.data.status === 200) {
                                destinationParam = {
                                    latitude: response.data.data.latitude,
                                    longitude: response.data.data.longitude
                                };
                            }
                        } else if (orderAddressTypeId === ADDRESS_TYPE_ANOTHER_HUB || orderAddressTypeId === ADDRESS_TYPE_OWN_HUB) {
                            response = await PndRestApi.GetHubById(data.fromUniqueId);
                            if (response && response.status === 200 && response.data.status === 200) {
                                destinationParam = {
                                    latitude: response.data.data?.latitude,
                                    longitude: response.data.data?.longitude
                                };
                            }
                        } else if (orderAddressTypeId !== ADDRESS_TYPE_HUB_CUSTOMER || orderAddressTypeId !== ADDRESS_TYPE_MERCHANT_CUSTOMER) {
                            // Directly using data.latitude and data.longitude if the address type doesn't match specific cases
                            destinationParam = {
                                latitude: data.latitude,
                                longitude: data.longitude
                            };
                        }

                        if (destinationParam) {
                            console.error('No value found:', destinationParam);
                        } else {
                            // showNotification(
                            //     "theme-light",
                            //     "ltr",
                            //     "Error",
                            //     "Unable to fetch destination coordinates. Please try again later.",
                            // );
                            console.error('Unable to fetch destination coordinates. Please try again later');
                        }
                    }

                    const updatedTableData = await Promise.all(
                        tableData.map(async (rider) => {
                            if (rider.riderId && rider.riderLatitude && rider.riderLongitude) {
                                const originParam = {
                                    latitude: rider.riderLatitude,
                                    longitude: rider.riderLongitude,
                                };
                                if (originParam && destinationParam && destinationParam?.latitude && destinationParam?.longitude) {
                                    const routeData = await calculateTTP(originParam, destinationParam);
                                    if (routeData) {

                                        return { ...rider, ttp: routeData.duration, distance: routeData.distance };
                                    }
                                }
                            }
                            return rider;
                        })
                    );
                    setReactTableData({ tableHeaderData: columns, tableRowsData: updatedTableData });
                }
            } else if (response1 && response1.status === 200 && response1.data.status === 204) {
                setNoFreeRiderFound(true);
            }
            else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1.data.status}`,
                    `Message:${response1.data.message}`,
                );
                toggle();
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                "Error",
                "Error while fetching the Data",
            );
        }
    };

    const toggle = () => {
        setModalShow(prevState => !prevState);
        setSelectedDriverId(null);
    }

    const handleRadioClick = (temData) => {
        setSelectedDriverId(temData?.riderId);
        setTempData(temData);
    };


    const columns = useMemo(() => {
        const columnsArray = [
            {
                Header: '#',
                accessor: (row, i) => i + 1, // Or just use Cell below for more control
                disableGlobalFilter: true,
                disableSortBy: true,
                width: 15,
                Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
            },
            {
                Header: 'Selection',
                accessor: 'riderId',
                disableSortBy: true,

                Cell: ({ row }) => (
                    <div>
                        {(row.original.vehicleId !== null) && (
                            <Radio
                                checked={row.original.riderId == selectedDriverId}
                                onClick={(event) => {
                                    handleRadioClick(row.original)
                                }}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: 'Rider Name',
                accessor: 'riderName',
                disableGlobalFilter: true,
            },
            {
                Header: 'Vehicle Plate No.',
                accessor: 'plateNo',
                Cell: ({ value }) => {
                    return value ? (
                        <span>{value}</span>
                    ) : (
                        <Tooltip title="No vehicle is assigned to this Rider.">
                            <Cancel style={{ color: 'red' }} />
                        </Tooltip>
                    );
                },
                disableGlobalFilter: false,
            },


            {
                Header: 'Rider Unique Id',
                accessor: 'riderUniqueId',
                disableGlobalFilter: true,
            },
            {
                Header: "Rider Status",
                accessor: "riderStatusInfo",
                disableSortBy: false,

                Cell: ({ row }) => (
                    <>
                        {row.original?.riderStatusId === 3 ? (
                            <h6><Badge bg="success">{row.original?.riderStatusDesc}</Badge></h6>
                        ) : row.original?.riderStatusId === 6 ? (
                            <h6><Badge bg="primary">{row.original?.riderStatusDesc}</Badge></h6>
                        ) : row.original?.riderStatusId === 9 && (
                            <h6><Badge bg="warning">{row.original?.riderStatusDesc}</Badge></h6>
                        )}
                    </>
                )
            },

        ];

        if (isOrderType === ORDER_TYPE_DROP_OFF) {
            columnsArray.push(
                {
                    Header: 'Idle Time',
                    accessor: 'idleTime',
                    disableGlobalFilter: false,
                },
                {
                    Header: 'TTH (min)',
                    accessor: 'travelTimeToHub',
                    disableGlobalFilter: true,
                }
            );
        } else {
            columnsArray.push(
                {
                    Header: 'TTP (min)',
                    accessor: 'ttp',
                    disableGlobalFilter: true,
                }
            );
        }

        return columnsArray;
    }, [selectedDriverId, isOrderType, selectedItem]);
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: true,
        withPagination: true,
        withSearchEngine: true,
        manualPageSize: [10, 50, 100, 1000],
        placeholder: 'Search by Rider Name, Plate No. ...',
    };

    const handleLinkClick = () => {
        setRiderRedirect(true);
    };

    if (isRiderRedirect) {
        return <Redirect to="/web_app/views/rider_view" />;
    }
    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    {isOrderNo &&
                        <h4 className="text-modal  modal__title mt-1 text-uppercase"  >
                            Selected Order is {isOrderNo}
                        </h4>
                    }
                </div>
                <div className="modal-body m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span className="account__logo-accent text-light"> */}
                        <form className="form-animated" >
                            <Col lg={12} md={12}>
                                {reactTableData && reactTableData?.tableRowsData && !isNoFreeRiderFound ?
                                    <Row>
                                        <Col lg={12} md={12}>
                                            <ReactTableBase
                                                name={"t('instution_type.view.name_map')"}
                                                key={'searchable'}
                                                columns={columns}
                                                data={reactTableData?.tableRowsData}
                                                tableConfig={tableConfig}
                                            />
                                        </Col>
                                    </Row> :
                                    <Row>
                                        <div><h6 className="page-title">No riders are currently available. Please click Rider Details link to view active riders.</h6></div>

                                        <div><Tooltip title="Click here to view the Active Rider Details">
                                            <Link to={`/web_app/views/rider_view`} onClick={handleLinkClick} style={{ cursor: 'pointer' }}><h6>Rider Details</h6>

                                            </Link>
                                        </Tooltip>
                                        </div>
                                    </Row>
                                }

                            </Col>
                            {/* : <div style={{color:"black"}}>Right now all the Riders are Busy</div> */}
                            {isTempData &&
                                <div className="form__OnboardingButton">
                                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                        <Button color="primary" type="button" className="next" onClick={handleAssignButtonClick}>Assign</Button>
                                    </ButtonToolbar>
                                </div>
                            }
                        </form>
                        {/* </span>
                        </span> */}
                    </div>

                </div>
            </Modal>

        </div>
    );
};


FreeRiderDetails.propTypes = {
    FreeRiderDetails: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
    return {};
};
export default connect(mapStateToProps)(reduxForm({ form: 'FreeRiderDetailsForm', enableReinitialize: true })(FreeRiderDetails));

